module.exports = __webpack_public_path__ + "img/swt-logo.a50f636a.png";